import "./App.css";

const sections = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "resources", label: "Resources" },
  { id: "contact", label: "Contact" },
  { id: "policy", label: "Policies" },
];

function App() {
  return (
    <div className="app-shell">
      <nav className="primary-nav">
        <span className="logo">Hyderabad Church</span>
        <ul>
          {sections.map((section) => (
            <li key={section.id}>
              <a href={`#${section.id}`}>{section.label}</a>
            </li>
          ))}
        </ul>
      </nav>

      <header className="hero" id="about">
        <img 
          src="/uploads/hero.jpg" 
          alt="Hyderabad Church - A community hub for the Christian community in Hyderabad" 
          style={{ width: '100%', maxHeight: '400px', objectFit: 'cover' }} 
        />
        <p className="eyebrow">Hyderabad Church · Empowering Community</p>
        <h1>Welcome to Hyderabad Church</h1>
        <p className="lede">
          At Hyderabad Church, we believe in the power of community and charity. Our mission is to uplift those in need and foster a spirit of compassion and generosity. Join us as we embark on a journey to make a difference in the lives of many. Our church is a beacon of hope, providing support through various outreach programs, charity events, and volunteer opportunities. We invite you to be part of this transformative experience, where every act of kindness counts and every contribution helps us build a stronger community.
        </p>
        <p>
          Our vision extends beyond mere charity; we aim to create lasting relationships and empower individuals to rise above their circumstances. Through our dedicated efforts, we have seen countless stories of change and resilience. Whether it’s providing meals for the hungry, educational resources for children, or support for families in crisis, our commitment to service is unwavering. Together, we can create a ripple effect of positivity that reaches far and wide.
        </p>
        <p>
          As you explore our site, you will discover various ways to get involved. From attending our events to volunteering your time, there are numerous opportunities to make a meaningful impact. We believe that everyone has something to offer, and your unique talents can help us further our mission. Join us in spreading love and kindness throughout Hyderabad and beyond.
        </p>
        <div className="cta-row">
          <a href="#services" className="cta-button">Discover Our Services</a>
          <a href="#contact" className="secondary">Get Involved</a>
        </div>
      </header>

      <section className="cards" id="services">
        <article>
          <h2>Community Outreach</h2>
          <p>
            Our community outreach programs aim to provide support and resources to those in need. From food drives to educational workshops, we are committed to making a positive impact.
          </p>
        </article>
        <article>
          <h2>Charity Events</h2>
          <p>
            Join us for our upcoming charity events where we raise funds and awareness for various causes. Your participation can help change lives.
          </p>
        </article>
        <article>
          <h2>Volunteer Opportunities</h2>
          <p>
            We welcome volunteers to help us in our mission. Whether you can spare a few hours or want to commit long-term, your help is invaluable.
          </p>
        </article>
        <article>
          <h2>Support Our Mission</h2>
          <p>
            Your donations help us continue our work. Every contribution, no matter how small, makes a difference in the lives of those we serve.
          </p>
        </article>
      </section>

      <section className="resources" id="resources">
        <h2>Latest News & Updates</h2>
        <div className="resource-card">
          <h3><a href="/blog/post1">Community Food Drive Success</a></h3>
          <p>We recently held a food drive that collected over 1,000 pounds of food for local families in need. Thank you to everyone who contributed!</p>
        </div>
        <div className="resource-card">
          <h3><a href="/blog/post2">Upcoming Charity Gala</a></h3>
          <p>Join us for our annual charity gala on December 15th. Enjoy an evening of dinner, entertainment, and fundraising for our community programs.</p>
        </div>
        <div className="resource-card">
          <h3><a href="/blog/post3">Volunteer Spotlight: Meet Sarah</a></h3>
          <p>Read about Sarah's inspiring journey as a volunteer and how she has made a significant impact in our community.</p>
        </div>
      </section>

      <section className="contact" id="contact">
        <div>
          <h2>Contact Us</h2>
          <p>If you have any questions or would like to learn more about our programs, please reach out to us.</p>
          <ul>
            <li>Email: info@hyderabadchurch.com</li>
            <li>Phone: (123) 456-7890</li>
            <li>Location: Hyderabad, India</li>
          </ul>
        </div>
        <form>
          <label>
            Name
            <input type="text" placeholder="Jane Doe" required />
          </label>
          <label>
            Email
            <input type="email" placeholder="you@example.com" required />
          </label>
          <label>
            Message
            <textarea rows={4} placeholder="How can we help?" required />
          </label>
          <button type="submit">Send Message</button>
        </form>
      </section>

      <section className="policies" id="policy">
        <h2>Policies & Compliance</h2>
        <p>
          This site provides essential compliance resources. Customize the linked pages in{" "}
          <code>public/</code> to match your organization.
        </p>
        <ul className="policy-links">
          <li><a href="/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a></li>
          <li><a href="/terms" target="_blank" rel="noreferrer">Terms of Service</a></li>
          <li><a href="/contact" target="_blank" rel="noreferrer">Contact</a></li>
          <li><a href="/about" target="_blank" rel="noreferrer">About</a></li>
        </ul>
      </section>

      <div id="adsense" className="adsense-slot">
        <p>AdSense placeholder — replace with your ad code.</p>
      </div>

      <footer className="footer">
        <p className="disclaimer">Informational only. All donations are used to support our charitable activities.</p>
      </footer>
    </div>
  );
}

export default App;